import * as React from 'react';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';
import { WorksheetModel } from '../../models';
import { useAppStore } from '../../stores';
import './WorksheetChangesCount.less';

interface Props {
    worksheet: WorksheetModel;
}

const WorksheetChangesCount: React.FC<Props> = ({ worksheet }) => {
    const { worksheetsChangesStore, sessionStore } = useAppStore();

    const lastEditorInfo = React.useMemo(() => {
        if (!worksheet.changes.length) {
            return '';
        }

        const lastChange = worksheet.changes[worksheet.changes.length - 1];
        const editorName = sessionStore.getUserById(lastChange.createdBy);

        const changeDate = DateTime.fromJSDate(new Date(lastChange.createDate));

        if (!changeDate.isValid) {
            return `Edited by ${editorName}`;
        }

        const formattedTime = changeDate.toFormat('HH:mm');
        const formattedDate = changeDate.toFormat('dd LLL');

        return `Edited by ${editorName} at ${formattedTime} on ${formattedDate}`;
    }, [sessionStore, worksheet.changes]);

    if (!worksheet.changes.length) {
        return null;
    }

    return (
        <Tooltip title={lastEditorInfo}>
            <span
                className="worksheet-changes-count"
                onClick={() => worksheetsChangesStore.setIsChangesModalVisible(true)}
            >
                {worksheet.changes.length} change{worksheet.changes.length === 1 ? '' : 's'}
            </span>
        </Tooltip>
    );
};

export default observer(WorksheetChangesCount);
